import { create } from "zustand";
import { IUser, IUserMap } from "@/common/services/types";

interface IUsersState {
  users: IUserMap;
  updateUsers: (incomingUsers: IUser[]) => void;
  getUser: (username: string) => IUser | undefined;
}

export const useUsersStore = create<IUsersState>(
  (set, get) => ({
    users: {},
    updateUsers: (incomingUsers: IUser[]) => set((state) => {
      const updatedUsers = { ...state.users };

      incomingUsers.forEach((user: IUser) => {
        updatedUsers[user.username] = user;
      });

      return { users: updatedUsers };
    }),
    getUser: (username: string) => {
      const { users } = get();
      return users[username];
    },
  }),
);
